import { ToastContextDispatch } from "Context/CommonContext";
import React, { useState } from "react";
import { getAPIRequest } from "utilFunctions/Axios/AxiosRequestConfiguration";
const useQuizQuestions = () => {
  const ToastDispatch = React.useContext(ToastContextDispatch);
  const [selectedQuestions, setSelectedQuestions] = useState<any>([]);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  const fetchQuizById = async (url: string) => {
    getAPIRequest({
      url: url,
      success: (res: any) => {
        const { data: response } = res || {};
        const { data: dataRes, code, message } = response || {};
        const { questions } = dataRes || {};
        if (code === "NF_RECORD") {
          ToastDispatch({
            isOpen: true,
            type: "Error",
            message: message,
          });
        }
        const quests = questions.map((question: any) => ({
          questionId: question.question_id,
          questionText: question?.text,
          questionType: question?.q_type,
          lod1: question?.lod1,
          checked: true,
        }));

        setSelectedQuestions(quests);
        setIsLoading(false);
      },
      failure: (err: any) => {
        console.log(err);
      },
    });
    setIsLoading(false);
  };
  return {
    fetchQuizById,
    selectedQuestions,
    setSelectedQuestions,
    isLoading,
    setIsLoading,
  };
};

export default useQuizQuestions;
